<section header>
	<h2>
		<icon type="trash" (click)="removed.emit()" />
		{{ ('enum.task-action-type.' + taskType[selectedType]) | translate }}{{ taskTemplate.title ? (': ' + taskTemplate.title) : '' }}
	</h2>
</section>
<section>
	<custom-select [label]="'task-template.type' | translate"
				   [placeholder]="'task-template.type-placeholder' | translate"
				   [selectList]="taskTypeList"
				   [(value)]="selectedType" />

	<custom-input [label]="'task-template.title' | translate"
				  [inputType]="inputTypeEnum.Text"
				  [(value)]="taskTemplate.title"
				  [required]="true"
				  [placeholder]="'task-template.title-placeholder' | translate" />

	<div>
		<custom-input [label]="'task-template.default-deadline' | translate"
					  [inputType]="inputTypeEnum.Number"
					  [(value)]="taskTemplate.defaultDeadline"
					  [suffix]="'task-template.default-deadline-suffix-days' | translate"
					  [placeholder]="'task-template.default-deadline-placeholder' | translate" />
	</div>
	<div>
		<custom-input [label]="'task-template.step' | translate"
					  [inputType]="inputTypeEnum.Number"
					  [(value)]="taskTemplate.step" />
	</div>

	<tags [(selectedTags)]="taskTemplate.taskTemplateTags" [tags]="taskTemplateTags" />
</section>
